module.exports = __webpack_public_path__ + "static/media/linux4everyone_shells.538506bf.png";